import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  ModalExportList,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  getByFilterJenisHargaExport,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";

export default function FormFilterJasa({
  formFilter,
  setFormFilter,
  setNewData,
  title = "Daftar Jasa",
  type='jasa',
  titleExport="Export List Master Jasa",
  url = '/master/jasa/ms_jasa/list-export',
}) {
  const [showModalExportList, setShowModalExportList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterJenisHargaExport(formFilter, url);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const jenisHarga = useSelectOption(
    false,
    "/wmsfarmasi/master/harga/list",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );

  const handleChange = (text) => (e) => {
    const val = e.target.value;
    setFormFilter({
      ...formFilter,
      [text]: val,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isNull(formFilter.id_jenis_harga)) {
      defaultToastError("Pilih jenis harga terlebih dahulu");
    } else {
      await setNewData(formFilter.pages, formFilter.limit);
    }
  };

  return (
    <>
      <div>
        <form onSubmit={(e) => handleSubmit(e)}>
          <p className='fw-600 mb-1 mt-1'>{title}</p>
          <Grid container spacing={1}>
            <Grid item sm={4}>
              <InputOptionMaster
                name='id_jenis_harga'
                label='JENIS HARGA'
                id='id_jenis_harga'
                withSearch={false}
                data={jenisHarga}
                value={formFilter.id_jenis_harga}
                onChange={handleChange("id_jenis_harga")}
              />
            </Grid>

            <Grid item sm={4}>
              <InputTextMaster
                name='id'
                label='ID'
                placeholder='ID'
                id='id'
                value={formFilter.id}
                onChange={handleChange("id")}
              />
            </Grid>
            <Grid item sm={4}>
              <InputTextMaster
                name='nama'
                label='NAMA'
                placeholder='Nama'
                id='nama'
                value={formFilter.nama}
                onChange={handleChange("nama")}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='is_emr'
                label='EMR'
                id='is_emr'
                withSearch={false}
                value={formFilter.is_emr}
                onChange={handleChange("is_emr")}
                data={[
                  {
                    value: 0,
                    label: "Semua",
                  },
                  {
                    value: 1,
                    label: "Ada di EMR",
                  },
                  {
                    value: 2,
                    label: "Tidak ada di EMR",
                  },
                ]}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='is_rajal'
                label='RAWAT JALAN'
                id='is_rajal'
                withSearch={false}
                value={formFilter.is_rajal}
                onChange={handleChange("is_rajal")}
                data={[
                  {
                    value: 0,
                    label: "Semua",
                  },
                  {
                    value: 1,
                    label: "Rawat Jalan",
                  },
                  {
                    value: 2,
                    label: "Bukan Rawat Jalan",
                  },
                ]}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='is_ranap'
                label='RAWAT INAP'
                id='is_ranap'
                withSearch={false}
                value={formFilter.is_ranap}
                onChange={handleChange("is_ranap")}
                data={[
                  {
                    value: 0,
                    label: "Semua",
                  },
                  {
                    value: 1,
                    label: "Rawat Inap",
                  },
                  {
                    value: 2,
                    label: "Bukan Rawat Inap",
                  },
                ]}
              />
            </Grid>

            <Grid item sm={3}>
              <InputOptionMaster
                name='is_igd'
                label='IGD'
                id='is_igd'
                withSearch={false}
                value={formFilter.is_igd}
                onChange={handleChange("is_igd")}
                data={[
                  {
                    value: 0,
                    label: "Semua",
                  },
                  {
                    value: 1,
                    label: "IGD",
                  },
                  {
                    value: 2,
                    label: "Bukan IGD",
                  },
                ]}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            className='mt-1'
            alignItems='center'>
            <MasterButton
              name={"RESET"}
              outline={true}
              color={"danger"}
              type={"button"}
              size={"md"}
              onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
            />

            <div style={{ display: "flex", gap: 16 }}>
              <MasterButton
                type={"button"}
                color='primary-cyan'
                name={"Export List"}
                size='md'
                onClick={() => setShowModalExportList(!showModalExportList)}
              />
              <MasterButton
                type={"button"}
                color='warning'
                name={isLoading ? "Loading..." : "EXPORT"}
                disabled={isLoading}
                size='md'
                onClick={handleExport}
              />

              <MasterButton
                name={"CARI"}
                outline={true}
                color={"green"}
                type={"submit"}
                size={"md"}
              />
            </div>
          </Grid>
        </form>
        <br />
      </div>
      {showModalExportList && (
        <ModalExportList
          title={titleExport}
          showModal={() => setShowModalExportList(false)}
          type={type}
        />
      )}
    </>
  );
}
